<template>
  <div class="net-interest-income-container">
    <v-row>
      <v-col cols="12">
        <v-card class="pa-4">
          <v-card-title>
            <h1>Net Interest Income</h1>
          </v-card-title>
          <v-card-text>
            <p>This is the Net Interest Income section under Interest Rate Risk.</p>
            <p>This component is currently under development and will contain Net Interest Income-related functionality.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'NetInterestIncome',
  data () {
    return {}
  }
}
</script>

<style scoped>
.net-interest-income-container {
  padding: 20px;
}
</style>
